require('../../../lib/select2/select2-3.4.5/select2.min.js');
require('../../../lib/js/angularmodule/JV.Core.Directives.js');
require('../../../lib/ngStorage/ngStorage.min.js');
require('../../common/directives/jv.Datepicker.js');
require('../../common/directives/jv.Select2ModalDropdown');
require('../../common/directives/jv.Common.Currency.Directive');
require('../../common/directives/jv.MessageTemplate.js');
require('../../common/jv.Modal');
require('../../common/jv.TemplateLoader');
require('../../common/directives/jv.AjaxSelect');
require('../../common/directives/jv.FormTemplate.webpack.js');
require('../../common/jv.NumberFormat.mask.directive');
require('../../jhire/modules/jv.Cand.Add');
require('../../jhire/services/jv.Cand');
require('../../jhire/controllers/candidates/jv.Cand.Add.Controller');
require('../../jhire/controllers/candidates/jv.Cand.ViewFields');
require('../../jhire/controllers/candidates/jv.Cand.AppSource');

angular.module('jv.cand.add.app',[
    'jv.Common.Directives.Datepicker',
    'jv.Common.Directives.jvSelect2ModalDropdown',
    'jv.common.currency.directive',
    'jv.Common.Directives.MessageTemplate',
    'jv.Common.Modal',
    'jv.Common.TemplateLoader',
    'jv.Common.AjaxSelect',
    'jv.Common.Directives.Formtemplate',
    'jv.common.numberFormatter.directive',
    'jv.CandAdd',
    'jv.addCandidate.controller',
    'jv.candidate.appSource.controller'
]);